import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M5 13V11H19V13H5Z" xmlns="http://www.w3.org/2000/svg" />,
  "Minus"
);
